module.exports = "<footer class=\"footer fixed-bottom bg-light\">\n  <div class=\"container d-flex justify-content-between\">\n  </div>\n</footer>\n"